import React, {Component} from 'react'
import axios from 'axios'
import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';
import {api} from "../../../../api/index"
import {settings} from "../../../../config/general";


class AppSettingsSyncComponent extends Component {
	constructor(props) {
		super(props);

		// this.downloadCompanies = this.downloadCompanies.bind( this );

		this.state = {
			page: 0,
			progress: {
				companies: {
					min: 0,
					max: 100,
					value: 0,
				},
				users: {
					min: 0,
					max: 100,
					value: 0,
				},
				topics: {
					min: 0,
					max: 100,
					value: 0,
				},
				categories: {
					min: 0,
					max: 100,
					value: 0,
				},
			},
			buttons: {
				companies: {
					disabled: false
				},
				users: {
					disabled: false
				},
				topics: {
					disabled: false
				},
				categories: {
					disabled: false
				},
			},
			messages: {
				companies: {
					imported: 'Alle bedrijven zijn geïmporteerd'
				},
				users: {
					imported: 'Alle gebruikers zijn geïmporteerd'
				},
				topics: {
					imported: 'Alle topics zijn geïmporteerd'
				},
				categories: {
					imported: 'Alle categorieën zijn geïmporteerd'
				},
			}
		}
	}

	async writeData(data, type) {
		return new Promise((resolve) => {
			api[type].write(data).then(() => {
				resolve();
			});
		});
	}

	async processItems(items, type) {
		items.forEach(async (item) => {
			await this.writeData(item, type);
		});

		return Promise.resolve();
	}

	disableEnableButton(buttonName, disabled) {
		this.setState({
			...this.state,
			buttons: {
				...this.state.buttons,
				[buttonName]: {
					...this.state.buttons[buttonName],
					disabled: disabled
				}
			}
		})
	}

	showSnackbar( type ) {
		api.snackbar.showMessage(this.state.messages[type].imported);
	}

	downloadData(type) {
		this.disableEnableButton(type, true);

		axios.get( settings.general.ApiBaseUrl + '/wp-json/cams/v1/' + type)
			.then(async (response) => {

				this.setState({
					...this.state,
					progress: {
						...this.state.progress,
						[type]: {
							...this.state.progress[type],
							max: parseInt(response.headers['x-wp-totalpages'])
						}
					}
				});

				for (let i = 1; i <= response.headers['x-wp-totalpages']; i++) {
					await axios.get( settings.general.ApiBaseUrl + '/wp-json/cams/v1/' + type + '/page/' + i)
						.then(async (response) => {
							await this.processItems(response.data, type);
						});

					this.setState({
						...this.state,
						progress: {
							...this.state.progress,
							[type]: {
								...this.state.progress[type],
								value: i
							}
						}
					})
				}

				this.disableEnableButton(type, false);
				this.showSnackbar( type );

				this.setState({
					...this.state,
					progress: {
						...this.state.progress,
						[type]: {
							...this.state.progress[type],
							value: 0
						}
					}
				});
			});
	}

	render() {
		return (
			<div className="medium-12 cell">
				<div className="grid-x grid-container grid-padding-x">
					<div className="small-12 cell">
						<h2>Synchronisatie</h2>
						<p>Op deze pagina kan je diverse data vanuit WordPress importeren in CAMS.</p>

						<table>
							<tbody>
							<tr>
								<td width="100%">Bedrijvengids</td>
								<td>
									<RaisedButton
										onClick={this.downloadData.bind(this, 'companies')}
										label="Importeren"
										disabled={this.state.buttons.companies.disabled}
									/>
								</td>
							</tr>
							<tr>
								<td colSpan="2">
									<LinearProgress
										mode="determinate"
										value={this.state.progress.companies.value}
										max={this.state.progress.companies.max}
										mikn={this.state.progress.companies.min}
									/>
								</td>
							</tr>
							<tr>
								<td width="100%">Gebruikers</td>
								<td>
									<RaisedButton
										onClick={this.downloadData.bind(this, 'users')}
										label="Importeren"
										disabled={this.state.buttons.users.disabled}
									/>
								</td>
							</tr>
							<tr>
								<td colSpan="2">
									<LinearProgress
										mode="determinate"
										value={this.state.progress.users.value}
										max={this.state.progress.users.max}
										mikn={this.state.progress.users.min}
									/>
								</td>
							</tr>
							<tr>
								<td width="100%">Topics</td>
								<td>
									<RaisedButton
										onClick={this.downloadData.bind(this, 'topics')}
										label="Importeren"
										disabled={this.state.buttons.topics.disabled}
									/>
								</td>
							</tr>
							<tr>
								<td colSpan="2">
									<LinearProgress
										mode="determinate"
										value={this.state.progress.topics.value}
										max={this.state.progress.topics.max}
										mikn={this.state.progress.topics.min}
									/>
								</td>
							</tr>
							<tr>
								<td width="100%">Categorie&euml;n</td>
								<td>
									<RaisedButton
										onClick={this.downloadData.bind(this, 'categories')}
										label="Importeren"
										disabled={this.state.buttons.categories.disabled}
									/>
								</td>
							</tr>
							<tr>
								<td colSpan="2">
									<LinearProgress
										mode="determinate"
										value={this.state.progress.categories.value}
										max={this.state.progress.categories.max}
										mikn={this.state.progress.categories.min}
									/>
								</td>
							</tr>
							</tbody>
						</table>

					</div>
				</div>
			</div>
		)
	}
}

export default AppSettingsSyncComponent


// WEBPACK FOOTER //
// ./src/application/components/settings/sync/index.js